class Menu {
    constructor() {
        this.toggle = document.querySelector('.menu__toggle');
        this.nav = document.querySelector('.menu');
        this.overlay = document.querySelector('.overlay');

        this.init();
    }

    init() {
        if (this.toggle) {
            this.toggle.addEventListener('click', () => {
                this.nav.classList.toggle('hidden');
                this.overlay.classList.toggle('hidden');
                Array.from(this.toggle.querySelectorAll('img')).forEach((icon) => {
                    icon.classList.toggle('hidden');
                });
            });
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', () => {
                this.nav.classList.add('hidden');
                this.overlay.classList.add('hidden');
                Array.from(this.toggle.querySelectorAll('img')).forEach((icon) => {
                    icon.classList.toggle('hidden');
                });
            });
        }
        if (window.innerWidth < 768) {
            Array.from(document.querySelectorAll('nav ul li a')).forEach((item) => {
                item.addEventListener('click', () => {
                    this.nav.classList.add('hidden');
                    this.overlay.classList.add('hidden');
                    Array.from(this.toggle.querySelectorAll('img')).forEach((icon) => {
                        icon.classList.toggle('hidden');
                    });
                });
            });
        }
    }
}

export default Menu;
